import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import MaterialTable from 'material-table';
import { toast } from 'react-toastify';
import apiService from '../../../services.js/apiService';
import { Error } from '../../../common/constants';
import DateSelect from '../../common/DateSelect';

// set default last 7 days
const defaultDateSet = {
  fromDate: moment().subtract(7, 'days').format('YYYYMMDD'),
  toDate:   moment().subtract(1, 'days').format('YYYYMMDD'),
};

const SelectOptions = [
  {
    label: 'All Time',
    value: 'allTime',
  },
  {
    label: 'Last Month',
    value: 'lastMonth',
  },
  {
    label: 'Last Two weeks',
    value: 'lastTwoWeeks',
  },
  {
    label: 'Last week',
    value: 'lastWeek',
  },
];

function AnalyticsSelection() {
  const [postViews, setPostViews] = useState([]);
  const [pageViews, setPageViews] = useState([]);
  const [highLightsViews, setHighLightsViews] = useState([]);
  const [searchViews, setSearchViews] = useState([]);
  const [searchNearbyViews, setSearchNearbyViews] = useState([]);
  const [selectOption, setSelectOption] = useState({});
  const [loadingForPageViews, setLoadingForPageViews] = useState(true);
  const [loadingForPostViews, setLoadingForPostViews] = useState(true);
  const [loadingForHighlightViews, setLoadingForHighlightViews] = useState(true);
  const [loadingForSearchViews, setLoadingForSearchViews] = useState(true);
  const [loadingForSearchNearByViews, setLoadingForSearchNearByViews] = useState(true);

  const getPageViews =  async ({ fromDate = defaultDateSet.fromDate, toDate = defaultDateSet.toDate, option = SelectOptions[3] }) => {
    setLoadingForPageViews(true);
    const result = await apiService.totalSelectionPageViews({ fromDate, toDate });
    setPageViews(result);
    setSelectOption((prevState) => ({
      ...prevState,
      pageViews: option,
    }));
    setLoadingForPageViews(false);
  };

  const getPostViews = async ({ fromDate = defaultDateSet.fromDate, toDate = defaultDateSet.toDate, option = SelectOptions[3] }) => {
    setLoadingForPostViews(true);
    const result = await apiService.postViewsSelection({ fromDate, toDate });
    setPostViews(result);
    setSelectOption((prevState) => ({
      ...prevState,
      postViews: option,
    }));
    setLoadingForPostViews(false);
  };

  const getHighlightsViews = async ({ fromDate = defaultDateSet.fromDate, toDate = defaultDateSet.toDate, option = SelectOptions[3] }) => {
    setLoadingForHighlightViews(true);
    const result = await apiService.highlightsSelection({ fromDate, toDate });
    setHighLightsViews(result);
    setSelectOption((prevState) => ({
      ...prevState,
      highLightsViews: option,
    }));
    setLoadingForHighlightViews(false);
  };

  const getSearchViews = async ({ fromDate = defaultDateSet.fromDate, toDate = defaultDateSet.toDate, option = SelectOptions[3] }) => {
    setLoadingForSearchViews(true);
    const result = await apiService.searchSelection({ fromDate, toDate });
    setSearchViews(result);
    setSelectOption((prevState) => ({
      ...prevState,
      searchViews: option,
    }));
    setLoadingForSearchViews(false);
  };

  const getSearchNearbyViews = async ({ fromDate = defaultDateSet.fromDate, toDate = defaultDateSet.toDate, option = SelectOptions[3] }) => {
    setLoadingForSearchNearByViews(true);
    const result = await apiService.searchNearbySelection({ fromDate, toDate });
    setSearchNearbyViews(result);
    setSelectOption((prevState) => ({
      ...prevState,
      searchNearbyViews: option,
    }));
    setLoadingForSearchNearByViews(false);
  };

  useEffect(() => {
    try {
      getPageViews({});
      getPostViews({});
      getHighlightsViews({});
      getSearchViews({});
      getSearchNearbyViews({});
    } catch (error) {
      toast.error(Error.ReportToIT);
    }
  }, []);

  return (
    <div className="">
      <div className="row my-2">
        <div className="col-sm-12 col-md-6 col-lg-6 my-2">
          <MaterialTable
            columns={[
              { title: 'Name', field: 'name' },
              { title: 'Page Id', field: 'id' },
              { title: 'count', field: 'count' },
            ]}
            onRowClick={async (event, rowData) => {
              window.open(`/admin/page/${rowData.id}`, '_blank');
            }}
            isLoading={loadingForPageViews}
            data={pageViews}
            options={{
              search:          false,
              filtering:       false,
              pageSize:        10,
              pageSizeOptions: [],
            }}
            components={{
              Toolbar: () => (
                <div className="container-flud p-3 m-3">
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 justify-content-center align-items-center">
                      <Typography variant="h6">Top 20 page views</Typography>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <DateSelect
                        onChange={getPageViews}
                        options={SelectOptions}
                        value={selectOption.pageViews}
                      />
                    </div>
                  </div>
                </div>
              ),
            }}
          />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 my-2">
          <MaterialTable
            columns={[
              { title: 'Name', field: 'name' },
              { title: 'Post Id', field: 'id' },
              { title: 'count', field: 'count' },
            ]}
            onRowClick={async (event, rowData) => {
              try {
                const post = await apiService.getPostById(rowData.id);
                window.open(`/admin/page/${post.pageId}/post/${rowData.id}`, '_blank');
              } catch (error) {
                toast.error(error);
              }
            }}
            isLoading={loadingForPostViews}
            data={postViews}
            options={{
              search:          false,
              filtering:       false,
              pageSize:        10,
              pageSizeOptions: [],
            }}
            components={{
              Toolbar: () => (
                <div className="container-flud p-3 m-3">
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 justify-content-center align-items-center">
                      <Typography variant="h6">Top 10 post views</Typography>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <DateSelect
                        onChange={getPostViews}
                        options={SelectOptions}
                        value={selectOption.postViews}
                      />
                    </div>
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      <div className="row my-2">
        <div className="col-sm-12 col-md-6 col-lg-6 my-2">
          <MaterialTable
            columns={[
              { title: 'Name', field: 'name' },
              { title: 'count', field: 'count' },
            ]}
            isLoading={loadingForHighlightViews}
            data={highLightsViews}
            options={{
              search:          false,
              filtering:       false,
              pageSize:        10,
              pageSizeOptions: [],
            }}
            components={{
              Toolbar: () => (
                <div className="container-flud p-3 m-3">
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 justify-content-center align-items-center">
                      <Typography variant="h6">Top 10 highlights views</Typography>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <DateSelect
                        onChange={getHighlightsViews}
                        options={SelectOptions}
                        value={selectOption.highLightsViews}
                      />
                    </div>
                  </div>
                </div>
              ),
            }}
          />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 my-2">
          <MaterialTable
            columns={[
              { title: 'Name', field: 'name' },
              { title: 'count', field: 'count' },
            ]}
            data={searchViews}
            isLoading={loadingForSearchViews}
            options={{
              search:          false,
              filtering:       false,
              pageSize:        10,
              pageSizeOptions: [],
            }}
            components={{
              Toolbar: () => (
                <div className="container-flud p-3 m-3">
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 justify-content-center align-items-center">
                      <Typography variant="h6">Top 10 search views</Typography>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <DateSelect
                        onChange={getSearchViews}
                        options={SelectOptions}
                        value={selectOption.searchViews}
                      />
                    </div>
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      <div className="row my-2">
        <div className="col-sm-12 col-md-6 col-lg-6 my-2">
          <MaterialTable
            columns={[
              { title: 'Name', field: 'name' },
              { title: 'count', field: 'count' },
            ]}
            isLoading={loadingForSearchNearByViews}
            data={searchNearbyViews}
            options={{
              search:          false,
              filtering:       false,
              pageSize:        10,
              pageSizeOptions: [],
            }}
            components={{
              Toolbar: () => (
                <div className="container-flud p-3 m-3">
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 justify-content-center align-items-center">
                      <Typography variant="h6">Top 10 search nearby views</Typography>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <DateSelect
                        onChange={getSearchNearbyViews}
                        options={SelectOptions}
                        value={selectOption.searchNearbyViews}
                      />
                    </div>
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AnalyticsSelection;
